<script>
export default {
    name: 'menu-item',
    props: ['item', 'initLevel'],
    computed:{
        currentPath() {
            return this.$route.path
        },
        setLevel(){
            let level = parseInt((this.initLevel-0.2)/0.3)
            return 'margin-left: ' + level*16 + 'px'
        },

    },
    data(){
        return {
            open: false
        }
    },
    watch:{
        $route:{
            handler(v){
                this.open = v.path.startsWith(this.item.group)
            },
            deep: true
        }
    },
    created(){
        this.open = this.$route.path.startsWith(this.item.group)
    },
    mounted() {
      let domList = document.getElementsByClassName('q-item__section--avatar');
      Object.keys(domList).forEach(item=>{
        domList[item].style='padding-right:0px;min-width:35px;';
        domList[item].firstChild.style = 'font-size:22px;';
      });
      let domList2 = document.getElementsByClassName('q-item__section--side');
      Object.keys(domList2).forEach(item=>{
        domList2[item].style='padding-left:0px;padding-right:0px;';
      });
      let domList3 = document.getElementsByClassName('q-item__section--avatar');
      Object.keys(domList3).forEach(item=>{
        domList3[item].style='min-width:40px;';
      });
    }
}
</script>
<template>
    <div class="EMIS__drawer-item">
        <q-item v-if="!item.children" dense style="padding-top: 10px;padding-bottom: 10px;padding-left:60px;padding-right:5px;margin-left: 0px" clickable v-ripple :class="currentPath==item.to?'menu-active':''"
            :to="item.to" >
<!--            <q-item-section avatar :style="setLevel"><q-icon :name="item.icon"/></q-item-section>-->
            <q-item-section><q-item-label class="text-weight-bold main-menu">{{item.title}}</q-item-label></q-item-section>
        </q-item>
        <q-expansion-item v-else dense expand-separator :header-inset-level="initLevel" :to="item.path" :icon="item.icon"
        :label="item.title" :caption="item.caption" v-model="open" header-class="text-grey-8 text-weight-bold" class="f-item" header-style="padding:5px;padding-left:12px">
            <div v-for="(it,index) in item.children" :key="index">
                <menu-item :item="it" :init-level="initLevel+0.3"/>
            </div>

        </q-expansion-item>

<!--      <q-expansion-item v-else dense expand-separator :header-inset-level="initLevel" :to="item.path" :icon="item.icon"-->
<!--                        :label="item.title" :caption="item.caption" v-model="open" header-class="text-grey-8 text-weight-bold f-item" header-style="padding-left:25px;padding-top:10px;padding-bottom:10px">-->
<!--        <template v-slot:header>-->
<!--          <q-item dense style="padding:0px;margin:0px">-->
<!--            <q-item-section avatar><q-icon :name="item.icon"/></q-item-section>-->
<!--            <q-item-section><q-item-label class="text-weight-bold main-menu">{{item.title}}</q-item-label></q-item-section>-->
<!--          </q-item>-->
<!--        </template>-->
<!--        <div v-for="(it,index) in item.children" :key="index">-->
<!--          <menu-item :item="it" :init-level="initLevel+0.3"/>-->
<!--        </div>-->

<!--      </q-expansion-item>-->
    </div>
</template>
<!--<style lang="sass" scoped>-->
<!--.main-menu-->
<!--    margin-left: 12px-->
<!--.EMIS-->
<!--    &__drawer-item-->
<!--        .menu-expansion-->
<!--            color: #5f6368-->
<!--        .q-item-->
<!--            line-height: 24px-->
<!--            border-radius: 24px 0 0 24px-->
<!--            margin-left: 12px-->

<!--            .q-item__section&#45;&#45;avatar-->
<!--                padding-left: 12px-->
<!--                .q-icon-->
<!--                    color: #5f6368-->
<!--            .q-item__label:-->
<!--                color: #5f6368-->
<!--                letter-spacing: .01785714em-->
<!--                font-size: .875rem-->
<!--                font-weight: 500-->
<!--                line-height: 1.25rem-->
<!--        .menu-active-->
<!--            background-color: #2196f3-->
<!--            .q-item__section&#45;&#45;avatar-->
<!--                .q-icon-->
<!--                    color: #fff-->
<!--            .q-item__label:not(.q-item__label&#45;&#45;caption)-->
<!--                color: #fff-->
<!--</style>-->
<style lang="scss" scoped>
.EMIS__drawer-item>.q-item:hover{
  border-right:4px solid #757575;
  //background-color: #DEEDF9;
}
//.f-item:hover{
//  border-right:4px solid #757575;
//}
.menu-active {
  border-right: 4px solid;
  background-color: #EDF5FC;
}
.q-item__section--side {
  //padding-right: 0;
  padding-left: 0px;
}
</style>
